import { Dropdown } from "primereact/dropdown";

// Шаблон отображения варианта выбора в выпадающем списке
function getItemTemplate(option: any, enumObject: any) {
    return <span>{enumObject?.[option]}</span>;
}

function getValueTemplate(value: any, enumObject: any) {
    return <span>{value ? enumObject?.[value] : ''}</span>;
}

// Шаблон фильтра с вариантами выбора
export function getOptionsRowFilterTemplate(
    options: { value: any; filterApplyCallback: (value: any) => void },
    variants: any[] | undefined,
    enumObject: any
) {
    const { filterApplyCallback, value } = options;
    return (
        <Dropdown
            appendTo="self"
            value={value}
            valueTemplate={(value: any): any => getValueTemplate(value, enumObject)}
            options={variants}
            onChange={(e) => filterApplyCallback(e.value)}
            itemTemplate={(option: any) => getItemTemplate(option, enumObject)}
            placeholder="Все"
            className="p-column-filter"
            showClear
            style={{ minWidth: '12rem' }}
        />
    );
}